import { useState, useEffect } from 'react';
import { elements } from '../data';
import { accounts } from './data';
import { getAnimationClass } from './../utils';

import Level1 from './images/1.jpg';

export default function ClassElements({ onComplete, numberOfAttempts }) {
  const [showIntroP, setShowIntroP] = useState(false);
  const [visibleAccounts, setVisibleAccounts] = useState(0);
  const [fadeOutAccountsSection, setFadeOutAccountsSection] = useState(false);
  const [hideAccountsSection, setHideAccountsSection] = useState(false);
  
  const [showSortingP, setShowSortingP] = useState(false);
  const [showImage1, setShowImage1] = useState(false);
  const [fadeOutSortingSection, setFadeOutSortingSection] = useState(false);
  const [hideSortingSection, setHideSortingSection] = useState(false);
  
  const [showElementsIntroP, setShowElementsIntroP] = useState(false);
  const [showElementsH2, setShowElementsH2] = useState(false);
  const [visibleElements, setVisibleElements] = useState(0);
  const [fadeOutElementsSection, setFadeOutElementsSection] = useState(false);
  const [hideElementsSection, setHideElementsSection] = useState(false);
  
  const [showFinalP, setShowFinalP] = useState(false);
  const [showFinalImage, setShowFinalImage] = useState(false);

  useEffect(() => {
    const timeouts = [];
    let currentTime = 0;
    
    currentTime += 500;
    timeouts.push(setTimeout(() => setShowIntroP(true), currentTime));
    
    currentTime += 4000;

    accounts.forEach((_, index) => {
      const delay = index < 5 ? 500 : 200;
      currentTime += delay;
      timeouts.push(setTimeout(() => setVisibleAccounts(index + 1), currentTime));
    });
    
    currentTime += 4000;
    timeouts.push(setTimeout(() => {
      setFadeOutAccountsSection(true);
      setShowSortingP(true);
    }, currentTime));
    
    currentTime += 4000;
    timeouts.push(setTimeout(() => setHideAccountsSection(true), currentTime));
    
    currentTime += 2000;
    timeouts.push(setTimeout(() => setShowImage1(true), currentTime));
    
    currentTime += 2000;
    timeouts.push(setTimeout(() => {
      setFadeOutSortingSection(true);
      setShowElementsIntroP(true);
    }, currentTime));
    
    currentTime += 1000;
    timeouts.push(setTimeout(() => setHideSortingSection(true), currentTime));
    
    currentTime += 3000;
    timeouts.push(setTimeout(() => setShowElementsH2(true), currentTime));
    
    elements.forEach((_, index) => {
      currentTime += 500;
      timeouts.push(setTimeout(() => setVisibleElements(index + 1), currentTime));
    });
    
    currentTime += 2000;
    timeouts.push(setTimeout(() => {
      setFadeOutElementsSection(true);
      setShowFinalP(true);
    }, currentTime));
    
    currentTime += 1000;
    timeouts.push(setTimeout(() => setHideElementsSection(true), currentTime));
    
    currentTime += 3000;
    timeouts.push(setTimeout(() => setShowFinalImage(true), currentTime));
    
    currentTime += 2000;
    timeouts.push(setTimeout(() => onComplete?.(), currentTime));
    
    return () => timeouts.forEach(clearTimeout);
  }, [onComplete]);

  return (
    <>
      <h1 className="animate-fade-in">Account Classification</h1>
      
      <div className="animation-section">
        {!hideAccountsSection && (
          <div className={`animation-content ${fadeOutAccountsSection ? 'animation-content--exiting' : ''}`}>
            <p className={getAnimationClass(showIntroP, fadeOutAccountsSection)}>
              Financial statements have many accounts, and getting familiar with them takes practice. This sorting exercise will help you quickly remember their classification.
            </p>
            
            <div 
              className={`transition-classification-accounts-container ${getAnimationClass(visibleAccounts > 0, fadeOutAccountsSection)}`}
            >
              {accounts.map((item, index) => (
                <div 
                  key={index}
                  className={`classification-account ${getAnimationClass(index < visibleAccounts)}`}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        )}

        {showSortingP && !hideSortingSection && (
          <div className={`animation-content ${fadeOutSortingSection ? 'animation-content--exiting' : ''}`}>
            <p className={getAnimationClass(showSortingP, fadeOutSortingSection)}>
              In this level, Accounts will appear for you to sort into the correct financial statement classification. The faster and more accurately you sort, the more points you earn!
            </p>
            
            {showImage1 && (
              <img 
                src={Level1} 
                alt="Classification Game" 
                className={`transition-image ${getAnimationClass(showImage1, fadeOutSortingSection)}`}
              />
            )}
          </div>
        )}

        {showElementsIntroP && !hideElementsSection && (
          <div className={`animation-content ${fadeOutElementsSection ? 'animation-content--exiting' : ''}`}>
            <p className={getAnimationClass(showElementsIntroP, fadeOutElementsSection)}>
              You'll start with sorting the <b>5 Elements of the financial statements</b>,<br/> The building blocks for all accounts.
            </p>
            
            {showElementsH2 && (
              <h2 className={getAnimationClass(showElementsH2, fadeOutElementsSection)}>
                The 5 Elements
              </h2>
            )}
            
            {showElementsH2 && (
              <div className={`transition-elements-container ${getAnimationClass(visibleElements > 0, fadeOutElementsSection)}`}>
                {elements.map((item, index) => (
                  <div 
                    key={index}
                    className={`transition-element ${getAnimationClass(index < visibleElements)}`}
                    style={{ backgroundColor: item.color }}
                  >
                    {item.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {showFinalP && (
          <div className="animation-content">
            <p className={getAnimationClass(showFinalP)}>
              And you'll have <b>up to {numberOfAttempts} attempts</b>, so no pressure. By the end, you'll feel more confident and prepared. You've got this!
            </p>
            
            {showFinalImage && (
              <img 
                src={Level1} 
                alt="Classification Game" 
                className={`transition-image ${getAnimationClass(showFinalImage)}`}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
}